
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Layout', component.exports)
}
export default {
	props: {
		as: {
			type: String,
			default: 'div'
		}
	},
	render: function(createElement) {
		return createElement(
			this.as, // tag name
			{
				class: 'layout'
			},
			this.$slots.default // array of children
		);
	}
};
